///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Avatar from "../../Avatar";
import CloseIcon from "../../icons/CloseIcon";
import ErrorIcon from "../../icons/ErrorIcon";
import messages from "../../../helpers/messages";
import { formatDateAndTime } from "../../../helpers/formatDateAndTime";

function UserMessage(props) {
  return (
    <div
      className="m-auto border-bottom-grey pt-8 pb-8 mx-16"
      data-testid={props["data-testid"]}
    >
      <Avatar
        className="grid__cell inline-block"
        imageSource={props.profilePicture}
        size={36}
        data-testid={`${props["data-testid"]}-avatar`}
        alt={props.fullName}
        textContent={props.nameInitials}
        fontSize={12}
      />
      <div className="grid__cell t90 pl-12">
        {props.isError ? (
          <CloseIcon
            height="12px"
            width="12px"
            fill="#343434"
            className="cursor-pointer fr"
            onClick={props.deleteMessage}
          />
        ) : (
          <div className="fr">
            {!props.isPreviouslySeenByUser && (
              <p className="unread-message round inline-block mb-0 mr-4">
                &nbsp;
              </p>
            )}
            <p className="color-gray font-size-10 inline-block mb-0">
              {formatDateAndTime(props.createDateUTC + "Z", props.userDivision)}
            </p>
          </div>
        )}
        <p className="font-bold mb-2">{props.fullName}</p>
        <p
          className="word-wrap mb-2"
          dangerouslySetInnerHTML={{
            __html: props.userMessage
          }}
        ></p>
        {props.isError && (
          <p className="error mb-0 mt-4">
            <ErrorIcon fill="#B00020" height="14px" width="14px" />
            <span className="px-4">
              {messages.thisMessageCouldNotBeDelivered.defaultMessage}
            </span>
            <button
              className="error underline no-focus"
              onClick={props.sendUserMessage}
            >
              {messages.tryagain.defaultMessage}
            </button>
            <span className="pl-4">{messages.orDelete.defaultMessage}</span>
          </p>
        )}
      </div>
    </div>
  );
}

export default UserMessage;
